module.exports = __webpack_public_path__ + "static/Industry-Digital-Twin-7b93bcb203bd8ca50e108946605a531b.jpg";